import React from "react";

const AllPages = () => {
  return (
    <div>
      <table className="custom-table">
        <tbody>
          <tr>
            <td>
              {" "}
              <h2 style={{ fontSize: "15px" }}>Main Pages</h2>
            </td>
            <td>
              <h2 style={{ fontSize: "15px" }}>Admin Pages</h2>
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "15px" }}>
              {" "}
              <h3>
                <a target="_blank" href="http://localhost:3000/frontDesk">
                  Home Page
                </a>
              </h3>
              <h1>MIC Start</h1>
              <h3>
                <a href="http://localhost:3000/mic/mobile">Mobile</a>
              </h3>
              <h3>
                <a href="http://localhost:3000/mic/out">
                  Outdoor Entrance: Entrance Door on Top
                </a>
              </h3>
              <h3>
                <a href="http://localhost:3000/mic/mainTV">
                  Big TV or Right wall TV
                </a>
              </h3>
              {/* <h3>
                <a href="http://localhost:3000/rotate90">
                  90 Degree Rotated Page
                </a>
              </h3> */}
              <h3>
                <a href="http://localhost:3000/mic/270">
                  270 Degree Rotated Page
                </a>
              </h3>
              <h1>MIC End</h1>
              {/* <h3>
                <a href="http://localhost:3000/ramadanNamesView">
                  Ramadan Booking Name List
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/ramadanDailySlideShow">
                  Ramadan Daily Slide Show
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/transactionView">
                  Transaction Monthly In & Out Only
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/transactionMonthlyWeeklyViewPage">
                  Transaction Monthly & Weekly View Page
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/transactionAnalytics">
                  Transaction Analytics View
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/transactionWithPicture">
                  Transaction With Picture
                </a>
              </h3> */}
            </td>
            <td style={{ fontSize: "15px" }}>
              <h1>MIC Start</h1>

              <h3>
                <a href="http://localhost:3000/mic/forAll/mehdi/api">
                  Fetch Iqama Time
                </a>
              </h3>
              <h3>
                <a href="http://localhost:3000/mic/forAll/mehdi/admin">
                  View Iqama Time
                </a>
              </h3>

              <h3>
                <a href="http://localhost:3000/mic/forAll/mehdi/AddNewsAtBottom">
                  Bottom News Scroller Add
                </a>
              </h3>
              <h3>
                <a href="http://localhost:3000/mic/forAll/mehdi/combined/">
                  Add Updated Events
                </a>
              </h3>
              <h3>
                <a href="http://localhost:3000/mic/forAll/mehdi/addNamesRamadan">
                  Add Names for Ramadan
                </a>
              </h3>
              <h1>MIC End</h1>

              {/* <h3>
                <a href="http://localhost:3000/transactionAdmin">
                  Transaction Admin
                </a>
              </h3> */}
              {/* <h3>
                <a href="http://localhost:3000/transactionEdit">
                  Transaction Edit
                </a>
              </h3> */}
            </td>
          </tr>
        </tbody>
      </table>

      {/* CSS in the same page */}
      <style>
        {`
          .custom-table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          .custom-table td {
            border: 1px solid #333;
            width: 50%;
            padding: 12px;
            text-align: center;
            font-size: 1.2rem;
            background-color: #f9f9f9;
          }
          .custom-table td:first-child {
            background-color: #e0f7fa; /* light blue for first column */
          }
          .custom-table td:last-child {
            background-color: #ffe0b2; /* light orange for second column */
          }
        `}
      </style>
    </div>
  );
};

export default AllPages;
